"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AAColor = void 0;
__exportStar(require("./colors"), exports);
var AAColor;
(function (AAColor) {
    AAColor["GREEN"] = "#2EB62D";
    AAColor["ERROR"] = "#E12C2C";
    AAColor["YELLOW"] = "#EBA300";
    AAColor["GREY"] = "#001F32";
    AAColor["GREY1"] = "#505C62";
    AAColor["GREY2"] = "#C1C7CC";
    AAColor["GREY3"] = "#C6CACE";
    AAColor["GREY4"] = "#9299A3";
    AAColor["BLUE"] = "#0082D4";
    AAColor["MAROON"] = "#E12C6A";
    AAColor["PURPLE"] = "#6A45EE";
    AAColor["WHITE"] = "#FFFFFF";
    AAColor["BLUEGREY"] = "#394348";
    AAColor["BEIGE"] = "#F3EFEC";
    AAColor["SIXSENSE_GREEN"] = "#13bbb2";
    AAColor["SIXSENSE_BLUE"] = "#0068A9";
    AAColor["BLUE_0"] = "#B2D9F2";
    AAColor["BLUE_1"] = "#3AA1DE";
    AAColor["BLUE_2"] = "#002E49";
    AAColor["DARK_GREEN"] = "#0C7972";
})(AAColor = exports.AAColor || (exports.AAColor = {}));
